import styled, { css } from "styled-components";
import { CoreIconButton } from "@boi/components-core";
import { useDesignTokens } from "@boi/react-design-tokens";

type WrapperProps = {
  $variant: CoreIconButton.Variant;
};

export const Wrapper = styled.button<WrapperProps>`
  ${({ $variant }) => {
    const { tokens } = useDesignTokens();
    const { iconButton } = tokens;

    return css`
      all: unset;
      display: grid;
      place-items: center;
      padding: ${iconButton.padding[$variant]};
      cursor: pointer;

      &:disabled {
        cursor: not-allowed;
      }
    `;
  }}
`;

type InnerWrapperProps = {
  $variant: CoreIconButton.Variant;
};

export const InnerWrapper = styled.div<InnerWrapperProps>`
  ${({ $variant }) => {
    const { tokens } = useDesignTokens();
    const { iconButton } = tokens;

    return [
      css`
        position: relative;
        display: grid;
        place-items: center;
        padding: ${iconButton.inner.padding[$variant]};
        border-radius: ${iconButton.inner.radius[$variant]};
        background: ${iconButton.inner.backgroundColor[$variant].base};
        opacity: ${iconButton.inner.opacity.base};

        ${Wrapper}:disabled && {
          opacity: ${iconButton.inner.opacity.disabled};
        }

        svg {
          display: block;
          width: ${iconButton.inner.icon.width[$variant]};
          height: ${iconButton.inner.icon.height[$variant]};
          color: ${iconButton.inner.icon.color.base};
        }

        ${Wrapper}:not(:disabled):hover && {
          background: ${iconButton.inner.backgroundColor[$variant].hover};

          svg {
            color: ${iconButton.inner.icon.color.hover};
          }
        }

        ${Wrapper}:not(:disabled):active &&,
        ${Wrapper}:not(:disabled)[aria-pressed] &&,
        ${Wrapper}:not(:disabled)[aria-expanded] && {
          background: ${iconButton.inner.backgroundColor[$variant].active};

          svg {
            color: ${iconButton.inner.icon.color.active};
          }
        }

        ${Wrapper}:focus-visible && {
          outline-width: ${iconButton.inner.focusRing.width};
          outline-style: ${iconButton.inner.focusRing.style};
          outline-color: ${iconButton.inner.focusRing.color};
          outline-offset: ${iconButton.inner.focusRing.offset[$variant]};
        }
      `,
      $variant === "contained" &&
        css`
          &:after {
            content: "";
            position: absolute;
            inset: 0;
            border-radius: ${iconButton.inner.radius[$variant]};
            outline-width: ${iconButton.inner.stroke.contained.width};
            outline-style: ${iconButton.inner.stroke.contained.style};
            outline-color: ${iconButton.inner.stroke.contained.color.base};
            outline-offset: ${iconButton.inner.stroke.contained.offset};
          }

          ${Wrapper}:not(:disabled):hover &:after {
            outline-color: ${iconButton.inner.stroke.contained.color.hover};
          }

          ${Wrapper}:not(:disabled):active &:after {
            outline-color: ${iconButton.inner.stroke.contained.color.active};
          }
        `,
    ];
  }}
`;
